import { Card } from 'app/components/card';
import { AltiboxHjemIcon } from 'app/media';
import { useAppNavigation } from 'app/utils/navigation-utils';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { Typography } from 'app/component-library-wave';
import { getAnonymizedCurrentPageUrl, GtmElementCta } from 'app/utils/gtm-tracking-utils';
import { getDataLayers } from 'app/utils/trackingService';
import { HJEM_APP_URL } from './hjem-app';

import styles from './hjem-app.module.scss';

export const HjemAppNavigationLink = () => {
  const { t } = useTranslation();
  const link = HJEM_APP_URL;

  const handleClick = () => {
    getDataLayers().customEvents.pushButtonClickEvent({
      page_url: getAnonymizedCurrentPageUrl(),
      element_cta: GtmElementCta.INTERNET_SETTINGS_HJEM_APP_READ_MORE,
      element_url: link,
    });
  };

  return (
    <Card className={styles.card} containerClassName={styles.navigationLinkCard}>
      <div className={styles.iconContainer}>
        <AltiboxHjemIcon className={styles.hjemAppIcon} />
      </div>
      <div className={styles.navigationLinkTextContainer}>
        <Typography component="div" variant="uiText2">
          {t('pages.hjemApp.navLinkCta.name')}
        </Typography>
        <Typography component="div" variant="uiText4">
          {t('pages.hjemApp.navLinkCta.description')}
        </Typography>
      </div>
      <NavLink to={link} className={styles.navigationLinkAction} onClick={() => handleClick}>
        <Typography component="div" variant="uiText2">
          {t('pages.hjemApp.navLinkCta.action')}
        </Typography>
      </NavLink>
    </Card>
  );
};
